module.exports = __webpack_public_path__ + "media/slot-game/cola-97d14e84.svg";